import { startsWith } from 'ramda';

import {
  FETCH_POINTS,
  FETCH_POINTS_SUCCESS,
  FETCH_POINTS_ERROR,
  SET_PASSWORD_RECOVERY_CHANNEL,
  SET_PASSWORD_RECOVERY_CHANNEL_SUCCESS,
  SET_PASSWORD_RECOVERY_CHANNEL_ERROR,
  TOGGLE_POINT_EDITING_STATE,
  SAVE_NOTIFICATION_POINT,
  SAVE_NOTIFICATION_POINT_SUCCESS,
  SAVE_NOTIFICATION_POINT_ERROR,
  CONFIRM_NOTIFICATION_POINT_CODE,
  CONFIRM_NOTIFICATION_POINT_CODE_SUCCESS,
  CONFIRM_NOTIFICATION_POINT_CODE_ERROR,
  RESET_NOTIFICATION_POINT_CODE_VALIDATION,
  SEND_NOTIFICATION_POINT_CODE,
  SEND_NOTIFICATION_POINT_CODE_SUCCESS,
  SEND_NOTIFICATION_POINT_CODE_ERROR,
  CHANGE_PASSWORD,
  CHANGE_PASSWORD_SUCCESS,
  CHANGE_PASSWORD_ERROR,
  FETCH_OFFER,
  FETCH_OFFER_SUCCESS,
  FETCH_OFFER_ERROR,
  SAVE_ACCESS_CONFIG,
  SAVE_ACCESS_CONFIG_SUCCESS,
  SAVE_ACCESS_CONFIG_ERROR,
  TOGGLE_CONFIRMATION_CODE_POPUP,
  RESET_ERROR,
  FETCH_INTERNET_LOGIN,
  FETCH_INTERNET_LOGIN_SUCCESS,
  FETCH_INTERNET_LOGIN_ERROR,
  CHANGE_INTERNET_LOGIN,
  CHANGE_INTERNET_LOGIN_SUCCESS,
  CHANGE_INTERNET_LOGIN_ERROR,
  CHANGE_INTERNET_PASSWORD,
  CHANGE_INTERNET_PASSWORD_SUCCESS,
  CHANGE_INTERNET_PASSWORD_ERROR,
} from './constants';

import {
  initNotificationPoints,
  togglePointEditingState,
  updateNotificationPointValue,
  setCodeValidity,
  resetNotificationPointCodeValidation,
  toggleSavingStatus,
  toggleCheckingStatus,
  toggleCodeSendingStatus,
  toggleConfirmationCodePopup,
} from '../../common';

const initialState = {
  isPointsFetching: false,
  isPasswordChanging: false,
  isOfferFetching: false,
  isInternetLoginFetching: false,
  canChangeInternetLogin: false,
  internetLoginUpdatingStatus: {
    isUpdating: false,
    success: false,
    error: null,
  },
  internetPasswordUpdatingStatus: {
    isUpdating: false,
    success: false,
    error: null,
  },
  passwordUpdatingStatus: {
    isUpdating: false,
    success: false,
    error: null,
  },
  accessConfigUpdatingStatus: {
    isUpdating: false,
    success: false,
    error: null,
  },
  points: null,
  offer: null,
  internetLogin: null,
  error: null,
  pointsFetchingError: null,
  offerFetchingError: null,
  internetLoginFetchingError: null,
  fttbConfigureConnectionHelpUrl: null,
};

const changeTogglingStatusOfPasswordRecoveryChannel = (state, isToggling = true) => ({
  ...state,
  points: state.points
    .map((point) => ({
      ...point,
      isToggling,
    })),
});

const setPasswordRecoveryChannel = (state, type) => {
  if (state && state.points) {
    const points = state.points.map((point) => ({
      ...point,
      isToggling: false,
      isEnabled: point.type === type,
    }));

    return {
      ...state,
      points,
    };
  }

  return state;
};

export default function (state = initialState, action) {
  switch (action.type) {
    case FETCH_POINTS:
      return {
        ...state,
        isPointsFetching: true,
      };
    case FETCH_POINTS_SUCCESS:
      return initNotificationPoints({
        ...state,
        isPointsFetching: false,
        pointsFetchingError: null,
        points: action.data,
      });
    case FETCH_POINTS_ERROR:
      return {
        ...state,
        isPointsFetching: false,
        pointsFetchingError: action.error,
        points: null,
      };
    case FETCH_OFFER:
      return {
        ...state,
        isOfferFetching: true,
      };
    case FETCH_OFFER_SUCCESS:
      return {
        ...state,
        isOfferFetching: false,
        offerFetchingError: null,
        offer: action.data,
      };
    case FETCH_OFFER_ERROR:
      return {
        ...state,
        isOfferFetching: false,
        offerFetchingError: action.error,
        offer: null,
      };
    case SET_PASSWORD_RECOVERY_CHANNEL:
      return changeTogglingStatusOfPasswordRecoveryChannel(state, true);
    case SET_PASSWORD_RECOVERY_CHANNEL_SUCCESS:
      return setPasswordRecoveryChannel(state, action.data);
    case SET_PASSWORD_RECOVERY_CHANNEL_ERROR:
      return changeTogglingStatusOfPasswordRecoveryChannel({
        ...state,
        error: action.error,
      }, false);
    case TOGGLE_POINT_EDITING_STATE:
      return togglePointEditingState(state, action.data);
    case SAVE_NOTIFICATION_POINT:
      return toggleSavingStatus(state, action.data, true);
    case SAVE_NOTIFICATION_POINT_SUCCESS:
      return initNotificationPoints(
        togglePointEditingState(
          updateNotificationPointValue(state, action.data),
          {
            type: action.data.type,
            isEditing: false,
          },
        ),
      );
    case SAVE_NOTIFICATION_POINT_ERROR:
      return toggleSavingStatus({
        ...state,
        error: action.error,
      }, action.data, false);
    case CONFIRM_NOTIFICATION_POINT_CODE:
      return toggleCheckingStatus(state, action.data, true);
    case CONFIRM_NOTIFICATION_POINT_CODE_SUCCESS:
      return initNotificationPoints(setCodeValidity(state, action.data, false));
    case CONFIRM_NOTIFICATION_POINT_CODE_ERROR:
      return toggleCheckingStatus(
        setCodeValidity(state, action.data, true),
        action.data,
        false,
      );
    case RESET_NOTIFICATION_POINT_CODE_VALIDATION:
      return resetNotificationPointCodeValidation(state, action.data);
    case SEND_NOTIFICATION_POINT_CODE:
      return toggleCodeSendingStatus(state, action.data, true);
    case SEND_NOTIFICATION_POINT_CODE_SUCCESS:
      return toggleCodeSendingStatus(state, action.data, false);
    case SEND_NOTIFICATION_POINT_CODE_ERROR:
      return toggleCodeSendingStatus({
        ...state,
        error: action.error,
      }, action.data, false);
    case CHANGE_PASSWORD:
      return {
        ...state,
        passwordUpdatingStatus: {
          isUpdating: true,
          success: false,
          error: null,
        },
      };
    case CHANGE_PASSWORD_SUCCESS:
      return {
        ...state,
        passwordUpdatingStatus: {
          isUpdating: false,
          success: true,
          error: null,
        },
      };
    case CHANGE_PASSWORD_ERROR:
      return {
        ...state,
        passwordUpdatingStatus: {
          isUpdating: false,
          success: false,
          error: action.error,
        },
      };
    case SAVE_ACCESS_CONFIG:
      return {
        ...state,
        accessConfigUpdatingStatus: {
          isUpdating: true,
          success: false,
          error: null,
        },
      };
    case SAVE_ACCESS_CONFIG_SUCCESS:
      return {
        ...state,
        accessConfigUpdatingStatus: {
          isUpdating: false,
          success: true,
          error: null,
        },
        offer: {
          ...state.offer,
          xbrOfferAcceptType: action.data.xbrOfferAcceptType,
          actualVersion: action.data.version,
        },
      };
    case SAVE_ACCESS_CONFIG_ERROR:
      return {
        ...state,
        accessConfigUpdatingStatus: {
          isUpdating: false,
          success: false,
          error: action.error,
        },
      };
    case TOGGLE_CONFIRMATION_CODE_POPUP:
      return toggleConfirmationCodePopup(state, action.data);
    case RESET_ERROR:
      return {
        ...state,
        error: null,
      };
    case FETCH_INTERNET_LOGIN:
      return {
        ...state,
        isInternetLoginFetching: true,
      };
    case FETCH_INTERNET_LOGIN_SUCCESS:
      return {
        ...state,
        isInternetLoginFetching: false,
        internetLogin: startsWith('FTTB/', action.data.alias) ? action.data.alias.substring(5) : action.data.alias,
        canChangeInternetLogin: action.data.isChangeable,
      };
    case FETCH_INTERNET_LOGIN_ERROR:
      return {
        ...state,
        isInternetLoginFetching: false,
        internetLoginFetchingError: action.error,
      };
    case CHANGE_INTERNET_LOGIN:
      return {
        ...state,
        internetLoginUpdatingStatus: {
          isUpdating: true,
          success: false,
          error: null,
        },
      };
    case CHANGE_INTERNET_LOGIN_SUCCESS:
      return {
        ...state,
        fttbConfigureConnectionHelpUrl: action.payload,
        internetLoginUpdatingStatus: {
          isUpdating: false,
          success: true,
          error: null,
        },
      };
    case CHANGE_INTERNET_LOGIN_ERROR:
      return {
        ...state,
        internetLoginUpdatingStatus: {
          isUpdating: false,
          success: false,
          error: action.error,
        },
      };
    case CHANGE_INTERNET_PASSWORD:
      return {
        ...state,
        internetLoginUpdatingStatus: {
          isUpdating: true,
          success: false,
          error: null,
        },
      };
    case CHANGE_INTERNET_PASSWORD_SUCCESS:
      return {
        ...state,
        internetPasswordUpdatingStatus: {
          isUpdating: false,
          success: true,
          error: null,
        },
      };
    case CHANGE_INTERNET_PASSWORD_ERROR:
      return {
        ...state,
        internetPasswordUpdatingStatus: {
          isUpdating: false,
          success: false,
          error: action.error,
        },
      };
    default:
      return state;
  }
}
